import { useState } from 'react';
import MobileBanner from './components/MobileBanner/MobileBanner';
import * as S from './Login.style';
import LoginAuthRoutes from './LoginAuthRoute';
import LoginBackground from './components/LoginBackground/LoginBackground';
import { LoginLoaderContext } from './Login.context';

const Login = () => {
  const [showLoader, setShowLoader] = useState(false);

  return (
    <LoginBackground>
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
      <LoginLoaderContext.Provider value={{ showLoader, setShowLoader }}>
        {showLoader && (
          <S.LoginLoaderWrapper dataTestId="loader-login-screen">
            <S.Loader />
          </S.LoginLoaderWrapper>
        )}
        <S.FormContainer>
          <LoginAuthRoutes />
        </S.FormContainer>
      </LoginLoaderContext.Provider>
      <MobileBanner />
    </LoginBackground>
  );
};

export default Login;
